module.exports = __webpack_public_path__ + "images/feature/zhiren-notification-dialog-adb2cc8d723f0cc0de0535d5bc74977b.png";